<template>
  <search @search="search" v-model="searchValue">
    <my-refresh-more
      ref="refresh"
      slot="content"
      :pageSize="10"
      v-model="liveList"
      :getList="getList"
      :params="{searchValue}"
    >
      <div slot="list" class="goods-list">
        <div
          v-for="(item, index) in liveList"
          :key="index"
          class="goods-item"
          @click="navToDetailPage(item)"
        >
          <div class="image-wrapper">
            <van-image lazy-load
              class="image-wrapper-image"
              :src="item.cover.length>0?item.cover[0]:''"
              mode="aspectFill"
            ></van-image>
          </div>
          <div class="text-wrapper">
            <span class="title clamp">{{item.name}}</span>
            <span class="price-box">{{item.startTime}}</span>
            <div class="price-box">
              <span
                class="price"
              >{{item.type==1?'免费':item.type==2?'¥'+item.price:item.type==3?'加密':''}}</span>
              <span>{{item.isLiveRecord?'回放':'结束'}}</span>
            </div>
          </div>
        </div>
      </div>
    </my-refresh-more>
  </search>
</template>

<script>
import search from '../base.vue';
export default {
  components: {
    search
  },
  data () {
    return {
      searchValue: '',
      headerPosition: "fixed",
      headerTop: "0px",
      loadingType: 'more',
      liveList: [],
      page: 1,
    };
  },
  created () {

  },
  methods: {
    search (value) {
      this.searchValue = value
      this.$refs.refresh.refreshList()
    },
    getParams () {
      return { searchValue: this.searchValue }
    },
    getList (page, size, param) {
      let {
        searchValue
      } = param
      let params = {
        page: page,
        size: size,
        name: searchValue,
      }
      return new Promise((resolve, reject) => {
        this.$http.request(this.$http.pathMap.myLiveList, 'get', params).then(res => {
          resolve(res.data)
        })
      })
    },
    //详情
    navToDetailPage (item) {
      let id = item.id;
      this.$router.push({
        path: '/onlinePages/live/live',
        query: {
          id
        }
      })
    },
    stopPrevent () { }
  },
}
</script>

<style lang="scss" scoped>
/* 商品列表 */
.goods-list {
  display: flex;
  flex-wrap: wrap;
  padding: 0 15px;
  background: #fff;

  .goods-item {
    display: flex;
    flex-direction: row;
    width: 100%;
    padding-bottom: 10px;
    padding-top: 10px;
  }

  .image-wrapper {
    width: 110px;
    height: 110px;
    border-radius: 3px;
    overflow: hidden;

    .image-wrapper-image {
      width: 100%;
      height: 100%;
      opacity: 1;
    }
  }
  .text-wrapper {
    flex: 1;
    margin-left: 10px;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
  }
  .title {
    font-size: $uni-font-size-lg;
    color: $font-color-dark;
  }

  .price-box {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding-right: 5px;
    font-size: $uni-font-size-base;
    color: $font-color-light;
  }

  .price {
    font-size: $uni-font-size-base;
    color: var(--theme-font-color);
    line-height: 1;
  }
}
</style>
